/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-restricted-globals */
import { CircularProgress } from "@mui/material";
import React, { createContext, useContext, useState } from "react";

export const LoadingContext = createContext<{
    loading: boolean,
    showLoading: Function,
    hideLoading: Function
}>({
    loading: false,
    showLoading: () => { },
    hideLoading: () => { },
});

function Loading() {
    return <div style={{width: '100%', flex: 1, backgroundColor: 'transparent', position: 'absolute', zIndex: 9999, top: 0, textAlign: 'center', height: '100%'}}>
        <div style={{paddingTop: innerHeight / 2}}>
            <CircularProgress />
        </div>
    </div>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function LoadingProvider({ children }: any) {
    const [loading, setLoading] = useState<boolean>(false);
    const value = {
        loading,
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
    };
    return (
        <LoadingContext.Provider value={value}>
            {loading && <Loading />}
            {children}
        </LoadingContext.Provider>
    );
}

export function useLoading() {
    const context = useContext(LoadingContext);
    if (!context) {
        throw new Error("useLoading must be used within LoadingProvider");
    }
    return context;
}